import PropTypes from 'prop-types'
import React from 'react'

import {
  Item,
  IconStyled,
  IconWrapper,
  Description,
  LinkInlineArrowLongStyled,
} from './styles'

/**
 * ResultsListItem
 *
 * @param {object} props - properties of component
 * @returns {node} ResultsListItem
 */
const ResultsListItem = props => {
  const { isActive, title, icon, onClick, isWhiteArrow, separatorColor } = props

  return (
    <Item {...{ isActive, onClick, separatorColor }}>
      <IconWrapper>
        <IconStyled id={icon} />
      </IconWrapper>
      <Description>
        <LinkInlineArrowLongStyled
          isWhite={isWhiteArrow}
          isHoverable={false}
          classNameArrow="results-list-item__arrow"
        >
          {title}
        </LinkInlineArrowLongStyled>
      </Description>
    </Item>
  )
}

ResultsListItem.propTypes = {
  icon: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isWhiteArrow: PropTypes.bool,
  separatorColor: PropTypes.string,
}

ResultsListItem.defaultProps = {
  isWhiteArrow: false,
}

export default ResultsListItem
